import Submitted from './Submitted'

export default Submitted
